import React, { useState } from 'react';
import { Modal, Button, Table } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import './AlarmsModal.less';
import { TIME_AND_DATE_FORMATS } from '@app/constants';
import { timeFormatter } from '@app/utils/helpers';
import { RoomModalInterface } from '@app/types/rooms';
import { AlarmsStatusIndicator } from '@app/common/AlarmsModal/components/AlarmsStatusIndicator';

const AlarmsModal = ({ isModalVisible, handleOk, data, loading }: Partial<RoomModalInterface>) => {
  dayjs.extend(utc);
  dayjs.extend(relativeTime);

  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  const handlePaginationChange = (page: number, pageSize: number) => {
    setPage(page);
    setPageSize(pageSize);
  };

  const tableColumns = [
    {
      title: 'Day/time',
      width: 120,
      align: 'left' as const,
      sorter: (a, b) => a.timestamp - b.timestamp,
      render: alarm => {
        const time = timeFormatter(alarm.timestamp * 1000, TIME_AND_DATE_FORMATS.FULL_DATE_TIME_FORMAT);
        return <span>{time}</span>;
      }
    },
    {
      title: 'Value',
      width: 30,
      align: 'left' as const,
      sorter: (a, b) => a.value - b.value,
      render: alarm => alarm?.value
    },
    {
      title: 'Alarm',
      width: 30,
      align: 'left' as const,
      sorter: (a, b) => a.type.localeCompare(b.type),
      render: alarm => (
        <span className="status-indicator">
          <AlarmsStatusIndicator isCleared={!alarm.status} />
          {alarm.type}
        </span>
      )
    }
  ];

  return (
    <Modal
      centered
      className="room-modal"
      closable={false}
      destroyOnClose={true}
      open={isModalVisible}
      onOk={handleOk}
      footer={[
        <Button key="submit" type="primary" onClick={handleOk}>
          OK
        </Button>
      ]}
    >
      <div className="alarms-modal">
        <div className="title-block">
          <div className="title">Last 24h alarms logs for "{data?.extraData?.roomName}"</div>
        </div>

        <Table
          className="alarms-table"
          dataSource={data?.alarms || []}
          columns={tableColumns}
          rowKey={(record, i) => `${record.timestamp}-${i}}`}
          pagination={{
            size: 'default',
            current: page,
            pageSize,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 25, 100],
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            onChange: handlePaginationChange
          }}
          scroll={{
            y: 430,
            scrollToFirstRowOnChange: true
          }}
          style={{
            minHeight: 480,
            height: 480
          }}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default AlarmsModal;
